import { assertDefined } from '@/utils/assertDefined';
import { getSortedConfigurationsOnView } from '@/model/draft/getSortedConfigurationsOnView';
import { getView } from '@/model/productType/getView';
import { StoreState } from '@/redux/types';
import { getConfigurationIds } from './getConfigurationIds';
import { getProductType } from './getProductType';
import { selectConfigurations } from './selectConfigurations';

export const selectSortedConfigurationsOnView = (viewId: string) => (state: StoreState) =>
  getSortedConfigurationsOnView(
    selectConfigurations(state),
    getConfigurationIds(state),
    assertDefined(getView(getProductType(state), viewId))
  );
